import React from 'react';
export function CostComparison() {
  const costs = [{
    sin: '3 hs de planificación × 48 semanas',
    real: '144 horas de tu vida por año'
  }, {
    sin: 'Sin benchmarks ni tests',
    real: 'Domingos de planificación sin saber si el alumno progresó'
  }, {
    sin: 'Material improvisado en clase',
    real: 'Desgaste profesional + alumnos que no ven resultados'
  }, {
    sin: 'Grupos con distintos niveles sin sistema',
    real: 'Alumnos que se pierden y no vuelven'
  }, {
    sin: 'Domingo buscando en YouTube',
    real: 'El mismo ciclo, el próximo año'
  }];
  return <section className="py-20 px-4 bg-surface2 border-y border-zinc-800" data-id="element-41">
      <div className="max-w-4xl mx-auto" data-id="element-42">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 flex items-center justify-center gap-2" data-id="element-43">
          <span data-id="element-44">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="overflow-x-auto mb-12" data-id="element-45">
          <table className="w-full text-left border-collapse min-w-[500px]" data-id="element-46">
            <thead data-id="element-47">
              <tr className="border-b border-zinc-800 text-sm" data-id="element-48">
                <th className="p-4 font-medium text-zinc-400 w-1/2" data-id="element-49">
                  Sin Combo Completo
                </th>
                <th className="p-4 font-medium text-red-400 w-1/2" data-id="element-50">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody className="text-sm" data-id="element-51">
              {costs.map((row, i) => <tr key={i} className="border-b border-zinc-800/50" data-id="element-52">
                  <td className="p-4 text-zinc-300" data-id="element-53">{row.sin}</td>
                  <td className="p-4 font-bold text-white bg-red-500/5" data-id="element-54">
                    {row.real}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-55">
          <h3 className="text-2xl font-bold text-primary mb-6" data-id="element-56">
            El próximo domingo puede ser diferente.
          </h3>
          <p className="text-xl text-zinc-300 italic font-medium" data-id="element-57">
            "El domingo que viene podés abrir el Tomo que corresponde, leer la
            clase del día y ejecutar. Sin buscar. Sin armar. Sin improvisar."
          </p>
        </div>
      </div>
    </section>;
}